import { db } from './database';
import { SpinHistory } from '../types';
import { generateUniqueId } from '../utils/random';

export async function getHistoryForWheel(wheelId: string): Promise<SpinHistory[]> {
  return await db.history.where('wheelId').equals(wheelId).reverse().sortBy('timestamp');
}

export async function logWinnerHistory(
  wheelId: string,
  winnerId: string,
  winnerLabel: string
): Promise<SpinHistory> {
  const item: SpinHistory = {
    id: generateUniqueId(),
    wheelId,
    winnerId,
    winnerLabel,
    timestamp: Date.now(),
  };
  await db.history.add(item);
  return item;
}

export async function deleteHistoryItem(id: string): Promise<void> {
  await db.history.delete(id);
}

export async function clearHistoryForWheel(wheelId: string): Promise<void> {
  await db.history.where('wheelId').equals(wheelId).delete();
}
